import Api from 'App/api'

export const getInsurances = Api.get({
  controller: 'insurance',
  action: 'list',
})

export const getTpInsurances = Api.get({
  controller: 'commercial_insurance',
  action: 'listWithSettings',
})

export const getInsuranceListWithSettings = Api.get({
  controller: 'insurance',
  action: 'listWithSettings',
})

export const saveInsurance = Api.postMultipart({
  controller: 'insurance',
  action: 'save',
})

export const saveTpInsurance = Api.postMultipart({
  controller: 'commercial_insurance',
  action: 'save',
})

export const deletePolicy = Api.post({
  controller: 'insurance',
  action: 'delete',
})

export const getEnrollmentLink = Api.get({
  controller: 'insurance',
  action: 'getEnrollmentlink',
})

export const submitInsuranceShoppingRequest = Api.post({
  controller: 'property_contact',
  action: 'contact',
})